import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/user/Login'
// import manage from '@/components/manage/index'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [{
        path: '/login',
        name: 'Login',
        component: Login
    }]
})


// WEBPACK FOOTER //
// ./src/router/index.js